<p>
  sem-graph-histogram works!
</p>
